module.exports = __webpack_public_path__ + "static/media/inguinalTape.4dfb4616.gif";